import src from "IMAGE";
export default { src, width: 5120, height: 848, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AJ+fnzaUlJQxg4ODLm5ubiaMjIwxj4+PMJaWljOnp6c4+FQO/M24g1AAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 1 }
